class ApiURL {
  ////==========================================================================
  ////Base URL Section
  ////==========================================================================
  ////Local
  //static BaseURL = "https://localhost:7268";

  ////Stage
  //static BaseURL ="https://test-service.touristhubindia.com";

  ////Production
  //static BaseURL = "http://103.168.18.29";  
  static BaseURL = "https://service.touristhubindia.com";  

  ////==========================================================================
  ////Image URL Section
  ////==========================================================================cls
  static BaseImageURL = this.BaseURL + "/uploadfiles/images";
  static HomeBannerImageURL = this.BaseImageURL + "/HomeBanner";
  static HomeDestinationImageURL = this.BaseImageURL + "/HomeDestination";
  static PackagesWeOfferImageURL = this.BaseImageURL + "/HomePackageWeOffer";
  //static TestimonialClientImageURL = "https://mdbcdn.b-cdn.net/img/Photos/Avatars";
  //static TestimonialClientImageURL = this.BaseImageURL + "/Testimonial";
  static HotPackageImageURL = this.BaseImageURL + "/HotPackages";
  static PackageTopBannerImageURL = this.BaseImageURL + "/Packages/TopBanners";
  static PackageDestinationBannerImageURL = this.BaseImageURL + "/Packages/Destinations";
  static HotelImageURL = this.BaseImageURL + "/Packages/Hotels";


  /*  static HomeServiceImageURL = this.BaseImageURL + "/HomeService";
   static BsetOfferImageURL = this.BaseImageURL + "/BestOffer";
   static PopularServiceImageURL = this.BaseImageURL + "/PopularService";
   static MarketplaceImageURL = this.BaseImageURL + "/Marketplace";
   static OtherServiceImageURL = this.BaseImageURL + "/OtherService";
    */

  ////====================================================================
  ////API URL Section
  ////===========================================================================
  static SaveCustomerEnquery = this.BaseURL + "/api/customer/saveCustomerEnquery";
  static GetAllOriginCities = this.BaseURL + "/api/customer/getAllOriginCities";

  //URL API's
  static GetAllURL = this.BaseURL + "/api/url/getAllURL";
  //static GetURLById = this.BaseURL + "/api/url/getURLById/{urlId}";
  static GetURLById(urlId) {
    return this.BaseURL + "/api/url/getURLById/" + urlId;
  }
  static SaveURL = this.BaseURL + "/api/url/saveURL";
  static DeleteURL = this.BaseURL + "/api/url/deleteURL";

  //TravelCircuit API's
  static GetAllTC = this.BaseURL + "/api/tc/getAllTC";
  static GetTCById(tcId) {
    return this.BaseURL + "/api/tc/getTCById/" + tcId;
  }
  static SaveTC = this.BaseURL + "/api/tc/saveTC";
  static DeleteTC = this.BaseURL + "/api/tc/deleteTC";

  //Location API's
  static GetAllLocation = this.BaseURL + "/api/location/getAllLocation";
  static GetAllLocationByTC(tcId) {
    return this.BaseURL + "/api/location/getAllLocationByTC/" + tcId;
  }
  static GetLocationById(locationId) {
    return this.BaseURL + "/api/location/getLocation/" + locationId;
  }
  static SaveLocation = this.BaseURL + "/api/location/saveLocation";
  static DeleteLocation = this.BaseURL + "/api/location/deleteLocation";

  //Vendor API's
  static GetAllVendor = this.BaseURL + "/api/vendor/getAllVendor";
  static GetAllVendorByLocation(locId, vcId) {
    return this.BaseURL + "/api/vendor/getAllVendorByLocation/" + locId+ "/" + vcId;
  }
  static GetVendorById(vendorId) {
    return this.BaseURL + "/api/vendor/getVendor/" + vendorId;
  }
  static SaveVendor = this.BaseURL + "/api/vendor/saveVendor";
  static DeleteVendor = this.BaseURL + "/api/vendor/deleteVendor";

   //Vendor Category API's
   static GetAllVendorCategory = this.BaseURL + "/api/vendorCategory/getAllVendorCategory";

  //RoomCategory API's
  static GetAllRoomCategory = this.BaseURL + "/api/roomCategory/getAllRoomCategory";
  static GetAllRoomCategoryByVendor(vendorId) {
    return this.BaseURL + "/api/roomCategory/getAllRoomCategoryByVendor/" + vendorId;
  }
  static GetRoomCategory(roomCategoryId) {
    return this.BaseURL + "/api/roomCategory/getRoomCategory/" + roomCategoryId;
  }
  static SaveRoomCategory = this.BaseURL + "/api/roomCategory/saveRoomCategory";

  //State API's
  static GetAllState = this.BaseURL + "/api/state/getAllState";
  static GetState(stateId) {
    return this.BaseURL + "/api/state/getStateById/" + stateId;
  }

  //Car API's
  static GetAllCar = this.BaseURL + "/api/car/getAllCar";
  static GetAllCarByVendor(vendorId) {
    return this.BaseURL + "/api/car/getAllCarByVendor/" + vendorId;
  }
  static GetCar(carId) {
    return this.BaseURL + "/api/car/getCar/" + carId;
  }
  static SaveCar = this.BaseURL + "/api/car/saveCar";

  //Specialist API's
  static GetAllSPL = this.BaseURL + "/api/specialist/getAllSPL";
  static GetSPLById(splId) {
    return this.BaseURL + "/api/specialist/getSPLById/" + splId;
  }
  static SaveSPL = this.BaseURL + "/api/specialist/saveSPL";
  static DeleteSPL = this.BaseURL + "/api/specialist/deleteSPL";

  //BookingType API's
  static GetAllBookingType = this.BaseURL + "/api/bookingType/getAllBookingType";
  static GetBookingTypeById(bkTypeId) {
    return this.BaseURL + "/api/bookingType/getBookingType/" + bkTypeId;
  }

  //AdditionalCharge API's
  static GetAllAdditionalCharge = this.BaseURL + "/api/additionalCharge/getAllAdditionalCharge";  
  static GetAdditionalCharge(chargeId) {
    return this.BaseURL + "/api/additionalCharge/getAdditionalCharge/" + chargeId;
  }
  static SaveAdditionalCharge = this.BaseURL + "/api/additionalCharge/saveAdditionalCharge";

  //Lead API's
  static GetLeadSrcTypes = this.BaseURL + "/api/lead/getAllLeadSrcTypes";
  static GetLeadStatus = this.BaseURL + "/api/lead/getAllLeadStatus";
  static GetAllLeadData = this.BaseURL + "/api/lead/getLeadData";
  static GetLeadDataById(leadId) {
    return this.BaseURL + "/api/lead/getLeadData/" + leadId;
  }
  static SaveLeadData = this.BaseURL + "/api/lead/saveLead";
  static DeleteLeadData = this.BaseURL + "/api/lead/delete";
  static GetLeadKPIData = this.BaseURL + "/api/lead/getLeadKPIData";
  static GetLeadKPIChartData = this.BaseURL + "/api/lead/getLeadKPIChartData";


  //Account API's
  ////static AdminLogin = this.BaseURL + "/api/account/adminLogin";
  static UserLogin = this.BaseURL + "/api/account/userLogin";
  static ChangePassword = this.BaseURL + "/api/account/changePwd";

  //Booking API's
  static GetAllBooking = this.BaseURL + "/api/booking/getAllBooking";
  static GetBooking = this.BaseURL + "/api/booking/getBooking";  
  static UpdateBooking = this.BaseURL + "/api/booking/updateBooking";

  //Sub-Booking API's
  static GetAllSubBooking = this.BaseURL + "/api/subBooking/getAllSubBooking";
  static GetSubBookingById(subBookingId) {
    return this.BaseURL + "/api/subBooking/getSubBooking/" + subBookingId;
  }
  static SaveSubBooking = this.BaseURL + "/api/subBooking/saveSubBooking";

  //Cusomer Payment API's
  //static GetAllCustomerPayment = this.BaseURL + "/api/customerPayment/getAllCustomerPayment";
  /* static GetCustomerPaymentsByBooking(bookingId) {
    return this.BaseURL + "/api/customerPayment/getCustomerPaymentsByBooking/" + bookingId;
  }
  static GetCustomerPayment(custPayId) {
    return this.BaseURL + "/api/customerPayment/getCustomerPayment/" + custPayId;
  } */
 
  static GetPaymentToCustomer = this.BaseURL + "/api/customerPayment/getCustomerPayment";
  static SaveCustomerPayment = this.BaseURL + "/api/customerPayment/saveCustomerPayment";
  static DeleteCustomerPayment = this.BaseURL + "/api/customerPayment/deleteCustomerPayment";

  //Vendor Payment API's
  static GetPaymentToVendor = this.BaseURL + "/api/vendorPayment/getVendorPayment";
  static SaveVendorPayment = this.BaseURL + "/api/vendorPayment/saveVendorPayment";
  static DeleteVendorPayment = this.BaseURL + "/api/vendorPayment/deleteVendorPayment";

  //Spot-Booking API's
  static GetAllSpotBookingVendor = this.BaseURL + "/api/spotBooking/getAllSpotBookingVendor";
  static GetAllSpotPayment = this.BaseURL + "/api/spotBooking/getAllSpotPayment";
  static GetSpotPaymentById = this.BaseURL + "/api/spotBooking/getSpotPaymentById";
  static SaveSpotPayment = this.BaseURL + "/api/spotBooking/saveSpotPayment";
  static DeleteSpotPayment = this.BaseURL + "/api/spotBooking/deleteSpotPayment";

  //Report API's
  static GetLeadReportData = this.BaseURL + "/api/report/getReportLeadData"
  static GetBookingReportData = this.BaseURL + "/api/report/getBookingReportData";
  static GetTravelReportData = this.BaseURL + "/api/report/getTravelReportData";
  static GetVendorPayableReportData = this.BaseURL+"/api/report/getVendorPayableReportData";
  static GetDayRegisterReportData = this.BaseURL+"/api/report/getDayRegisterReportData";
  static GetMoneyReceiptReportData = this.BaseURL + "/api/report/getMoneyReceiptReportData";
  static GetConfirmationVoucherReportData = this.BaseURL + "/api/report/getConfirmationVoucherReportData";
  static GetHotelBookingReportData = this.BaseURL + "/api/report/getHotelBookingReportData";

}

export default ApiURL;
